import {
    type MessageBus,
    makeMessageBus,
} from "~/core/messaging/create-message-bus";
import type { AllCartMessages } from "./messages/index.js";

export const cartMessageBus: MessageBus<AllCartMessages> = makeMessageBus();
